/**
 * Series names. A measure key is a **column id** (or monday's `default-label-count`), and a
 * chart legend that read `labor_budget_spent` instead of *Labor budget spent* would be reading
 * the database out loud. The titles come from the columns the aggregation could group by, which
 * is one query the canvas already needs for its settings pane.
 */
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { COUNT_MEASURE_KEY } from '@elizmonday/shared';
import { useTRPC } from '../../lib/trpc';

export function useMeasureTitles(boardIds: string[]): (key: string) => string {
  const trpc = useTRPC();
  const query = useQuery({
    ...trpc.dashboards.dimensionColumns.queryOptions({ boardIds }),
    enabled: boardIds.length > 0,
    staleTime: 60_000,
  });
  const rows = query.data ?? [];
  return useCallback(
    (key: string) => {
      if (key === COUNT_MEASURE_KEY) return 'Count of items';
      return rows.find((row) => row.id === key)?.title ?? key;
    },
    [rows],
  );
}
